"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Menu, X, Phone } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="flex gap-1">
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden lg:flex">
        <NavigationMenuList>
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className={`group relative inline-flex items-center justify-center py-2.5 text-xl font-medium tracking-wide transition-all outline-none ${item.label === "Kontakt" ? "bg-secondary text-foreground-secondary px-8 rounded-md hover:bg-secondary-hover hover:!text-foreground-secondary" : "px-6 text-foreground hover:!bg-transparent focus:!bg-transparent hover:text-primary"}`}>
                  {item.label}
                  {item.label !== "Kontakt" && <span className="absolute bottom-0 left-0 h-[3px] w-0 bg-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:w-full" />}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <div className="flex flex-col items-end md:flex-row md:items-center">
        <Button asChild variant="secondary" size="sm" className="md:hidden px-3 h-7 text-xs shadow-soft">
          <Link to="tel:504144406">
            <Phone className="size-3 mr-1" />
            Zadzwoń
          </Link>
        </Button>

        <Button variant="ghost" size="icon" className="md:hidden hover:!bg-transparent focus:!bg-transparent" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
          {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
        </Button>
      </div>

      {}
      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background border-b shadow-medium md:hidden">
          <nav className="container mx-auto px-6 py-4 flex flex-col gap-2">
            {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className={item.label === "Kontakt" ? "mx-6 my-2 px-6 py-4 text-2xl font-semibold tracking-wide text-foreground-secondary bg-secondary hover:bg-secondary-hover rounded-md transition-all text-center shadow-soft" : "px-6 py-5 text-2xl font-medium tracking-wide text-foreground hover:bg-accent hover:text-primary-dark rounded-md transition-all"} onClick={() => setMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Naglowek() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="nagłówek" className={`sticky top-0 z-50 w-full border-b border-border bg-primary-light/95 backdrop-blur-md transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${scrolled ? "h-16" : "h-20"}`}>
      <div className="container mx-auto px-6 h-full flex items-center justify-between">
        {}
        <Link to="/" className="flex items-center hover:opacity-80 transition-opacity">
          <img src="https://odszkodowaniaslupsk.info/wp-content/uploads/2026/02/freepik__zrb-te-logo-w-innym-formacie-nic-nie-zmieniaj__44698-1.png" alt="Odszkodowania Słupsk" className="!w-auto !h-[63px]" />
        </Link>

        {}
        <MenuProvider menu_id="28">
          <HeaderMenuConsumer />
        </MenuProvider>
      </div>
    </header>;
}